import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import GetUserToken from "../../utils/GetUserToken";
import "../../assets/stylesheets/newdoctorcitation.css";

export const PatientPickerOnboarding = ({
  patients,
  setEmail,
  setName,
  setFirstname,
  setLastname,
  setPhone,
  setAddress,
  setPatient_id,
  setUser,
  setInsurance,
  setIsOpenPatientModal,
  selectedPatient,
}) => {
  // translations
  const { t } = useTranslation();
  // auth
  const userToken = GetUserToken();
  // data
  const [patient, setPatient] = useState(null);
  const [insurances, setInsurances] = useState([]);

  const fetchDataInsurances = async () => {
    const url = process.env.REACT_APP_API_URL + "/insurances/index";
    var requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "api-key": process.env.REACT_APP_API_KEY,
        Authorization: userToken,
      },
      redirect: "follow",
    };
    const res = await fetch(url, requestOptions);
    const json = await res.json();
    if (json["insurances"]) {
      setInsurances(json["insurances"]);
    }
  };

  useEffect(() => {
    fetchDataInsurances();
  }, []);

  useEffect(() => {
    handleNameChange(null, selectedPatient);
  }, [selectedPatient]);

  const handleNameChange = (event, newValue) => {
    if (!newValue) {
      setPatient(null);
    } else {
      setPatient(newValue);
      setName(newValue.lastname + ", " + newValue.firstname);
      setFirstname(newValue.firstname);
      setLastname(newValue.lastname);
      setEmail(newValue.email);
      setPhone(newValue.phone);
      setAddress(newValue.address);
      setUser(newValue.user_id);
      setPatient_id(newValue.id);

      if (insurances.length !== 0 && newValue.insurance) {
        setInsurance(
          insurances.filter(
            (insurance) => insurance.id === Number(newValue.insurance)
          )[0].title
        );
      }
    }
  };

  return (
    <>
      <h1 className="subtitle-modal">{t("Calendar.Patient")}</h1>
      <div className="row">
        <div className="col-10">
          <FormControl style={{ minWidth: "100%", textAlign: "left" }}>
            <Autocomplete
              noOptionsText={
                "Need create a new patient? use add patient button"
              }
              id="name"
              name="name"
              options={patients.sort((a, b) =>
                a.lastname > b.lastname ? 1 : -1
              )}
              onChange={handleNameChange}
              getOptionLabel={(option) =>
                option["lastname"] + ", " + option["firstname"]
              }
              value={patient}
              renderInput={(params) => <TextField {...params} />}
            />
          </FormControl>
        </div>
        <div className="col-2">
          <button
            type="submit"
            className="add-patient-button"
            onClick={() => setIsOpenPatientModal(true)}
          >
            {t("Buttons.New")}
          </button>
        </div>
      </div>
    </>
  );
};
